import { render, staticRenderFns } from "./ProductMasterMatrix.vue?vue&type=template&id=4ef6ab48&scoped=true&"
import script from "./ProductMasterMatrix.vue?vue&type=script&lang=js&"
export * from "./ProductMasterMatrix.vue?vue&type=script&lang=js&"
import style0 from "./ProductMasterMatrix.vue?vue&type=style&index=0&id=4ef6ab48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef6ab48",
  null
  
)

export default component.exports